// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
const firebaseConfig = {
  apiKey: "AIzaSyCockmIUUxqWC05hUYl1dS4HNbLz9W7_zY",
  authDomain: "keep-1d174.firebaseapp.com",
  projectId: "keep-1d174",
  storageBucket: "keep-1d174.appspot.com",
  messagingSenderId: "823805771200",
  appId: "1:823805771200:web:6fca401dbb996a01badc25",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app)


